/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { ModalWindow } from '../../../modal';
import { useClickController } from '../../internal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонент подсказки в виде модального окна
 *
 * @export
 * @param {ITooltipMobileProps} props
 * @returns
 */
export function TooltipMobile(props) {
  const {
    title,
    header,
    children
  } = props;
  const {
    childrenProps,
    open,
    handleClose
  } = useClickController(props);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(children, childrenProps), /*#__PURE__*/_jsx(ModalWindow, {
      open: open,
      onClose: handleClose,
      title: header,
      content: title
    })]
  });
}